<div class="margin-top-2">
  @if (filterOptions && getFilters().length > 0) {
    <div><strong>Filtering Options</strong></div>
  }
  <ul>
    @for (filterOption of getFiltersByType("Other"); track filterOption) {
      <li>
        <div class="margin-top-1">{{ filterOption.Name }}</div>
        @for (filter of getVisibleFilters(filterOption); track filter) {
          <div class="margin-left-2">
            <label
              [ngClass]="{
                'is-selected': filter.IsSelected,
                'is-not-selected accessible-blue-on-gray': !filter.IsSelected
              }"
              [for]="filterOption.Name + filter.Id"
            >
              <input
                type="checkbox"
                [name]="filterOption.Name"
                [id]="filterOption.Name + filter.Id"
                [value]="filter.Id"
                [(ngModel)]="filter.IsSelected"
                (change)="updateCheckedCount()"
              />
              {{ filter.Display }} ({{ filter.Count }})
            </label>
          </div>
        }
        @for (filter of getMoreFilters(filterOption); track filter) {
          <div class="margin-left-2">
            <label
              [ngClass]="{
                'is-selected': filter.IsSelected,
                'is-not-selected accessible-blue-on-gray': !filter.IsSelected
              }"
              [for]="filterOption.Name + filter.Id"
            >
              <input
                type="checkbox"
                [name]="filterOption.Name"
                [id]="filterOption.Name + filter.Id"
                [value]="filter.Id"
                [(ngModel)]="filter.IsSelected"
                (change)="updateCheckedCount()"
              />
              {{ filter.Display }} ({{ filter.Count }})
            </label>
          </div>
        }
        @if (filterOption.Filters.length > 5) {
          <button
            class="usa-button usa-button--unstyled show-more-less"
            (click)="showMoreOrLessFilters(filterOption)"
          >
            <i [class]="getMoreOrLessFiltersClass(filterOption)"></i>
            {{ getMoreOrLessFiltersText(filterOption) }}
          </button>
        }
      </li>
    }
  </ul>
  @if (filterOptions && getFilters().length > 0) {
    <sidebar-filter-actions
      [currentCount]="checkedCount"
      [filtersStatus]="hasFiltersBeenApplied"
      (applyFilters)="applyFilters()"
      (clearFilters)="clearFilters()"
    >
    </sidebar-filter-actions>
  }
</div>
